import NavComponent from "../lib/nav_component";
import { PaneLinkComponentConfig } from "./pane_link_component";

export const PanePreComponentConfig = {
    componentTypeKey: 'PanePreComponent',
    baseHtmlClass: 'nav_option__pre',
    selector: '.nav_option__pre',
    // Links to handle (excluding foot action links)
    linkSelector: '.nav_option__pre__info > :not(.nav_option__pre__info__foot) a',
};

export class PanePreComponent extends NavComponent {

    static new(parentElement, paneOptionComponent) {
        let element = parentElement.querySelector(PanePreComponentConfig.selector);
        if (!element) return;
        return new PanePreComponent(element, paneOptionComponent);
    }

    constructor(id_or_element, paneOptionComponent) {
        super(id_or_element, PanePreComponentConfig);
        this.paneOptionComponent = paneOptionComponent;

        // Find the link element to dispatch events to
        this.targetLinkElement = paneOptionComponent.element.querySelector('.nav_option__link');

        // Add click handlers to all pre info links
        const links = this.element.querySelectorAll(PanePreComponentConfig.linkSelector);
        links.forEach(link => {
            link.addEventListener('click', this.handleClick.bind(this));
        });
    }

    handleClick(event) {
        if (this.paneOptionComponent.shouldPreventDefaultAction()) {
            event.preventDefault();
        }
        // Dispatch on the nav_option__link element so OnlineAppNavOption picks it up
        if (this.targetLinkElement) {
            this.targetLinkElement.dispatchEvent(new CustomEvent(PaneLinkComponentConfig.clickedEventName));
        }
    }
}
